
import Button from "@/components/base/Button"
import ViewAllButton from "@/components/base/button/ViewAllButton"
import BusinessLogo from "@/components/business/BusinessLogo"

const debounce = require("lodash.debounce")
const LIKE_LIMIT_PER_BUSINESS = 10
const LS_LIVE_LIKES = "livestream-like"
import { createLocalStorageEntity } from "@/helpers/localStorage"
import { mapGetters, mapActions } from "vuex"
import { mdiHeartOutline, mdiHeart, mdiMapMarker } from "@mdi/js"
import { routeToLivestreamSearch } from "@/helpers/routing"

export default {
    name: "LivestreamBusinesses",
    components: {
        BusinessLogo,
        Button,
        ViewAllButton,
    },
    icons: { mdiHeart, mdiHeartOutline, mdiMapMarker },
    data: () => ({
        routeToLivestreamSearch,
        debouncedLikeEvent: null,
        /** Saves executed like count
         * key: businessId,
         * value: likeCount
         */
        likes: {},
    }),
    computed: {
        ...mapGetters("livestream", ["currentBusiness", "isLive"]),
        isLikeDisabled() {
            return this.currentLikes >= LIKE_LIMIT_PER_BUSINESS
        },
        currentLikes() {
            return this.likes[this.currentBusiness?.id ?? 0] ?? 0
        },
    },
    mounted() {
        this.likes = createLocalStorageEntity(LS_LIVE_LIKES).get()
    },
    created() {
        this.debouncedLikeEvent = debounce(() => this.executeLike(), 500, {
            leading: true,
            trailing: true,
            maxWait: 500, // Implements a regular throttle
        })
    },
    methods: {
        ...mapActions("livestream", ["sendEvent"]),
        async like() {
            if (this.currentLikes >= LIKE_LIMIT_PER_BUSINESS) return
            this.debouncedLikeEvent()
        },
        executeLike() {
            this.sendEvent({ type: "like" })
            const businessId = this.currentBusiness?.id ?? 0
            const newLikes = this.currentLikes + 1
            this.$set(this.likes, businessId, newLikes)
            createLocalStorageEntity(LS_LIVE_LIKES).add(businessId, newLikes)
        },
    },
}
